enum VisitStatusSortableColumns {
  VisitDate = 'VisitDate',
}

export default VisitStatusSortableColumns;
